import { render, staticRenderFns } from "./home.vue?vue&type=template&id=4e564458&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=4e564458&prod&scoped=true&lang=css"
import style1 from "./home.vue?vue&type=style&index=1&id=4e564458&prod&scoped=true&lang=css"
import style2 from "./home.vue?vue&type=style&index=2&id=4e564458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../makeup-web/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e564458",
  null
  
)

export default component.exports